module.exports = __webpack_public_path__ + "img/fm_workflow_4.d2c6cf8e.png";